module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/placeholder.8d33528.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/placeholder.jpg
// module id = 6LxJ
// module chunks = 0